<pmt-action-modal [title]="modalTitleKey | transloco" [cancelButtonText]="'modal.closeButton' | transloco"
    [onlyCancel]="true">
    <div class="d-flex flex-column gap-1">
        <div *ngIf="!documentLinkUrl">
            <p>
                <span>
                    <i class="fa-solid fa-file-arrow-down fa-bounce"></i>
                </span>
                {{'documentLink.downloading' |transloco}}
            </p>
        </div>
        <div *ngIf="documentLinkUrl" class="d-flex flex-column flex-sm-row gap-2">
            <div class="flex-grow-1">
                <a [href]="documentLinkUrl" target="_blank" (click)="markAsRead()">
                    <span *ngIf="type == documentLinkTypeEnum.Link">
                        <i class="fa-solid fa-link"></i>
                    </span>
                    <span *ngIf="type == documentLinkTypeEnum.Document" class="px-1">
                        <i class="fa-solid fa-file"></i>
                    </span>
                    <span> {{name}}</span>
                </a>
            </div>
            <div>
                <span class="badge badge-warning" *ngIf="acceptanceDeadlineUtc != null && !isReadByUser">
                    {{'documentLink.readUntil' |transloco}}
                    {{acceptanceDeadlineUtc | date}}
                </span>
            </div>
        </div>
    </div>
    <!-- ToDo: Testtings for other file open options -->
    <!-- <div class="mt-3 d-flex flex-column gap-3">
        <div class="alert alert-secondary">Dies ist ein Test..</div>
        <button class="btn btn-default" (click)="clickAndOpen()">Click and open blob</button>
        <button class="btn btn-default" (click)="clickDownloadAndOpen()">Click and download from server</button>
        <button class="btn btn-default" (click)="clickAnIframe()">Click and open Iframe</button>
    </div>
    <div *ngIf="safeUrl">
        <img [src]="safeUrl" style="max-width: 100%; height: auto;" />
    </div> -->
</pmt-action-modal>